export { default } from './useAnalytics'

export const AnalyticsEvents = {
    PageView: 'PAGE_VIEW',
    ListView: 'LIST_VIEW',
    ListViewClick: 'LIST_VIEW_CLICK',
    ContentView: 'CONTENT_VIEW',
    JobApplyNow: 'JOB_APPLY_NOW',
    Tracking: 'BN_TRACKING'
}

export const TrackingEventNames = {
    ActiveUsage: "active usage",
    FirstVisit: "first visit",
    SessionStart: "session start",
    PageView: "page view",
    Video: "video content start",
    PaywallLoaded: "paywall loaded",
    EcommerceReceipt: "ecommerce receipt"
}